import React from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';

import CombinedHighlightedEntities from '../../../components/CombinedHighlightedEntities';

const ENTITIES_VIEW_DISPLAY = 'latest_articles';

const ParagraphSelectedArticles = ({ id, entity, ...args }) => {
  const isLargeVariant = entity.getIn(['field_is_large_variant', 0, 'value'], false);
  const selectedEntities = entity.getIn(['field_selected_articles'], Immutable.List()).map((entry) => entry.get('entity'));
  const articleTypeIds = entity.getIn(['field_article_types'], Immutable.List()).map((entry) => entry.get('target_id', null)).toJS();
  const subjectIds = entity.getIn(['field_subjects'], Immutable.List()).map((entry) => entry.get('target_id', null)).toJS();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  return (
    <div id={id}>
      <CombinedHighlightedEntities
        isLargeVariant={isLargeVariant}
        contentProps={{
          type: 'articles',
          link: entity.getIn(['field_link', 0, 'alias'], '/nl/artikelen'),
          title: entity.getIn(['field_title', 0, 'value']),
        }}
        selectedEntities={selectedEntities}
        viewDisplay={ENTITIES_VIEW_DISPLAY}
        viewFilters={{
          field_article_type_target_id: articleTypeIds,
          field_subjects_target_id: subjectIds,
        }}
        viewArgs={[args.id ?? args.nid]}
        key="combined_highlighted_articles"
      />
    </div>
  );
};

export default ParagraphSelectedArticles;
